import { render } from "./attributeProduct.vue?vue&type=template&id=14248c13"
import script from "./attributeProduct.vue?vue&type=script&lang=js"
export * from "./attributeProduct.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__